var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#divLoading {\n    display: block;\n    position: fixed;\n    z-index: 99999;\n    background-image: url(" + escape(require("../../../assets/img/loading.gif")) + ");\n    background-color: #666;\n    background-size: 100px 100px;\n    opacity: 0.7;\n    background-repeat: no-repeat;\n    background-position: center;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/student-checklist/student-checklist.component.css
// module id = ../../../../../src/app/pages/student-checklist/student-checklist.component.css
// module chunks = main